import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getoneuser, updateProfile } from '../../slice/userSlice';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { patchRequest, getRequest } from '../../apis/ApiInstence';
import { Link } from "react-router-dom";

const MySwal = withReactContent(Swal);

const Myprofile = () => {
  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  // Fetch user data from API
useEffect(() => {
  const userId = user?.response?._id || user?.response?.id;
  if (userId) {
    (async () => {
      try {
        const response = await getRequest(`customers/one/${userId}`);
        if (response.status === 200) {
          setFormData(response.data);
          dispatch(updateProfile({ data: response.data })); // sync redux + localstorage
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    })();
  }
}, [dispatch, user?.response?._id, user?.response?.id]);

  // Update form when redux changes
  useEffect(() => {
    if (user?.response) {
      setFormData({ ...user.response });
    }
  }, [user?.response]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = user?.response?._id || user?.response?.id;
    if (!userId) return;

    try {
      const url = `customers/${userId}`;
      const response = await patchRequest(url, {
        name: formData.name,
        address: formData.address,
      });

      if (response.status === 200) {
        dispatch(updateProfile({ data: { ...formData } }));
        await MySwal.fire({
          icon: 'success',
          title: 'Profile Updated',
          text: 'Your profile has been updated successfully!',
          confirmButtonColor: '#a1572f',
        });
        setIsEditing(false);
      } else {
        throw new Error(response.data?.message || 'Update failed');
      }
    } catch (err) {
      console.error('Update error:', err);
      MySwal.fire({
        icon: 'error',
        title: 'Update Failed',
        text: err.message || 'Something went wrong while updating your profile.',
        confirmButtonColor: '#d33',
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-orange-100 pt-44 pb-10">
      <div className="w-full max-w-lg bg-white p-8 rounded-2xl shadow-xl">
        <h2 className="text-3xl font-bold text-center mb-6 text-[#a1572f]">My Profile</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <Input label="Full Name" name="name" value={formData.name || ''} onChange={handleChange} readOnly={!isEditing} />
          <Input label="Email" name="email" type="email" value={formData.email || ''} readOnly />
          <Input label="Mobile Number" name="mobile" type="tel" value={formData.mobile || ''} readOnly />
          <Input label="Address" name="address" value={formData.address || ''} onChange={handleChange} readOnly={!isEditing} />

        {!isEditing ? (
          <button type="button" onClick={() => setIsEditing(true)} className="w-full py-2 bg-[#a1572f] text-white rounded-lg hover:bg-yellow-700">
            Edit Profile
          </button>
        ) : (
            <div className="flex gap-3">
              <button type="button" onClick={() => setIsEditing(false)} className="w-1/2 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600">
                Cancel
              </button>
              <button type="submit" className="w-1/2 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
                Save
              </button>
            </div>
          )}
          <Link
            to="/myorder"
            className="block w-full text-center py-2 border border-[#a1572f] text-[#a1572f] rounded-lg hover:bg-[#a1572f] hover:text-white"
          >
            View My Orders
          </Link>
        </form>
      </div>
    </div>
  );
};

const Input = ({ label, name, value, onChange, type = 'text', placeholder, readOnly }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      placeholder={placeholder || `Enter your ${label}`}
      onChange={onChange}
      readOnly={readOnly}
      className={`w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none ${
        readOnly ? 'bg-gray-100 cursor-not-allowed' : 'focus:ring-2 focus:ring-indigo-400'
      }`}
    />
  </div>
);

export default Myprofile;
